"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.APP_ENDPOINT = {
    getCountries: '/app/{{version}}/countries',
    getSearchApiKey: '/app/{{version}}/search-api-key?index=invoices&filters=company_uuid:{{companyUuid}}',
    getOperatorsByCountries: '/app/{{version}}/countries/services?service={{service}}',
};
